import { useRestAPI } from "./axiosAPI";

export function useDownloadFile() {

    const api = useRestAPI()

    const downoadFile = async (url: string, fileName: string) => {
            const response = await api.get({
                url: url,
                mode: 'protected',
                responseType: 'blob',
            });
    
            if (!response || response.success === false) {
                // Convert Blob error response to text
                const errorBlob = response as unknown as Blob;
                const errorText = await errorBlob.text();
                
                try {
                    const errorJson = JSON.parse(errorText); // Try parsing JSON
                    console.error('Download error:', errorJson);
                } catch {
                    console.error('Download error:', errorText);
                }
    
                throw new Error(errorText || 'Failed to download file');
            }
    
            const blob = new Blob([response as unknown as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName; // Set the filename
    
            document.body.appendChild(link);
            link.click();
    
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        
    };
    
    return{
        downoadFile
    }
    // Example Usage:
    // downloadTemplateEBOforecast('2024-03-19', '123');
}    